import styled from 'styled-components';
import { ExperienceSummary } from '../experienceSummary';
import { DiscountInfo } from '../experienceSummary/experienceSummary.styles';
import { winnowText, experienceTileTitle } from '../../../theme/typography';
import { media } from '../../../theme/media';
import { ExperienceLink } from '../../../shared/components/experienceLink';

export const Container = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 50px;

  ${media.desktop`
    min-width: 300px;
  `};
  width: 100%;
`;

export const Title = styled.h1`
  ${winnowText}
  ${experienceTileTitle}
  text-align: left;
  padding: 16px 0 0;

  ${media.tablet`
    padding-top: 28px;
  `}
`;

export const Summary = styled(ExperienceSummary)`
  padding: 8px 0 0;
  font-size: 14px;

  ${DiscountInfo} {
    font-size: 14px;
  }

  ${media.tablet`
    font-size: 18px;

    ${DiscountInfo} {
      font-size: 18px;
    }
  `};
`;

export const Link = styled(ExperienceLink)`
  text-decoration: none;
`;
